import { render } from "./Footer.vue?vue&type=template&id=5d51b762&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "@/assets/css/components/footer.css?vue&type=style&index=0&id=5d51b762&scoped=true&lang=css"

import exportComponent from "C:\\Users\\info\\Documents\\ownersite.vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d51b762"]])

export default __exports__